import { LLMPromptTemplate } from "models/LLMs/LLMPromptTemplate";
import BaseService from "./BaseService";
import { LLMResultDefinition } from "models/LLMs";

export class LLMPromptTemplatesService extends BaseService {
    public urlBase = "api/LLMPromptTemplates";

    public async getLLMPromptTemplates(
        abortSignal?: AbortSignal,
    ): Promise<LLMPromptTemplate[]> {
        const apiPath = "GetLLMPromptTemplates";
        return this.get(new URLSearchParams(), apiPath, abortSignal);
    }

    public async createLLMPromptTemplate(
        llmPromptTemplate: LLMPromptTemplate,
    ): Promise<LLMPromptTemplate> {
        const apiPath = "CreateLLMPromptTemplate";
        return this.post(
            JSON.stringify(llmPromptTemplate),
            new URLSearchParams(),
            apiPath,
        );
    }

    public async updateLLMPromptTemplate(
        llmPromptTemplate: LLMPromptTemplate,
    ): Promise<LLMPromptTemplate> {
        const apiPath = "UpdateLLMPromptTemplate";
        return this.post(
            JSON.stringify(llmPromptTemplate),
            new URLSearchParams(),
            apiPath,
        );
    }

    /**
     * Sets IsActive to false for the given llm prompt template
     * @param llmPromptTemplateId
     */
    public async deleteLLMPromptTemplate(llmPromptTemplateId: string) {
        const apiPath = "DeleteLLMPromptTemplate";
        return this.delete(
            new URLSearchParams({ llmPromptTemplateId }),
            apiPath,
        );
    }

    public async findLLMPromptTemplates(
        llmResultDefinitions: LLMResultDefinition[],
        abortSignal?: AbortSignal,
    ): Promise<LLMPromptTemplate[]> {
        const apiPath = "FindLLMPromptTemplates";
        return this.post(
            JSON.stringify({ llmResultDefinitions }),
            new URLSearchParams(),
            apiPath,
            undefined,
            undefined,
            abortSignal,
        );
    }
}
